<template>
  <div>
    <div>
			<span class="xbed-sub-title">优惠券管理</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>营销管理</BreadcrumbItem>
				<BreadcrumbItem>优惠券管理</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='优惠券ID' :label-width='100'>
        <Input type='text' v-model.trim="queryParams.cardId" style="width:200px;"></Input>
      </FormItem>
      <FormItem label='名称/简介' :label-width='100'>
        <Input type='text' v-model.trim="queryParams.titleDescription" style="width:200px;"></Input>
      </FormItem>
      <FormItem label='优惠类型' :label-width='100'>
				<Select v-model="queryParams.couponCardType" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="1">兑换券</Option>
					<Option :value="2">代金券</Option>
					<Option :value="3">折扣券</Option>
				</Select>
			</FormItem>
      <br/>
      <FormItem label='优惠成本' :label-width='100'>
				<Select v-model="queryParams.bearParty" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="1">Xbed承担</Option>
					<Option :value="2">业主承担</Option>
				</Select>
			</FormItem>
      <FormItem label='时效类型' :label-width='100'>
				<Select v-model="queryParams.type" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="1">领取后计时</Option>
					<Option :value="2">固定时间</Option>
				</Select>
			</FormItem>
      <FormItem label='领取方式' :label-width='100'>
				<Select v-model="queryParams.collectType" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="1">输入券码领取</Option>
					<Option :value="2">系统自动下发</Option>
				</Select>
			</FormItem>
      <br/>
      <FormItem :label-width='32'>
        <Button type="primary" @click="changeQueryKeyWord">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handlePromoDetail()">新增优惠券</Button>
      </FormItem>
      <Content>
        <Table stripe :columns="columnsList" :data='dataList' :loading='promoCodeLoading'></Table>
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer show-total :page-size="queryParams.size" :current="queryParams.page" :total="listTotal" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </Content>
    </Form>
  </div>
</template>

<script>
/* eslint-disable */
import API from "@/api";
import Utils from "../../utils";
import Moment from "moment";
export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
    
    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
      this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
    }
	},
  data () {
    return {
      /**
       * 优惠券优化
       * modify by lty
       * date: 20200214
       */
      dataList: [],
      listTotal: 0,
      promoCodeLoading: false,
      columnsList:[
        {
          title:'优惠券ID',
          key:'cardId',
          align:'center',
          width:200
        },
        {
          title:'优惠券名称',
          key:'title',
          align:'center',
          width:200,
          render: (h, params) => {
            return h('span', {
              style: {
                overflow: 'hidden',
                webkitLineClamp: 5,
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all',
                display: '-webkit-box',
                margin: '8px 0'
              },
              attrs: {
                title: params.row.title
              }
            }, params.row.title)
          }
        },
        {
          title:'对客简介',
          key:'description',
          align:'center',
          width:350,
          render: (h, params) => {
            return h('span', {
              style: {
                overflow: 'hidden',
                webkitLineClamp: 5,
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all',
                display: '-webkit-box',
                margin: '8px 0'
              },
              attrs: {
                title: params.row.description
              }
            }, params.row.description)
          }
        },
        {
          title:'优惠成本',
          key:'bearParty',
          align:'center',
          width:150,
          render: (h, params) => {
            return h('span', {}, ['', 'Xbed承担', '业主承担'][params.row.bearParty])
          }
        },
        {
          title:'优惠类型',
          key:'couponCardType',
          align:'center',
          width:150,
          render:(h,params) =>{
            return h('span', {}, ['','兑换券','代金券','折扣券'][params.row.couponCardType])
          }
        },
        {
          title:'优惠内容',
          align:'center',
          width: 280,
          render: (h, params) => {
            let text = `原价满${params.row.leastCost / 100}元 `
            switch (params.row.couponCardType) {
              case 3:
                text += `享${params.row.discount / 10}折 最高减${params.row.maxCost / 100}元`
                break;
              case 2:
                text += `减${params.row.reduceCost / 100}元`
                break;
              case 1:
                text += `减房费${params.row.exchangeNumber}晚 最高减${params.row.maxCost / 100}元`
                break;
              default:
                break;
            }
            return h('span', {}, text)
          }
        },
        {
          title:'时效类型',
          align:'center',
          width:150,
          render: (h, params) => {
            let type = '-'
            switch (params.row.type) {
              case 'DATE_TYPE_FIX_TERM':
                type = '领取后计时'
                break;
              case 'DATE_TYPE_FIX_TIME_RANGE':
                type = '固定时间'
                break;
              default:
                break;
            }
            return h('span', {}, type)
          }
        },
        {
          title:'有效期',
          align:'center',
          width:300,
          render: (h, params) => {
            let dealine = '-'
            switch (params.row.type) {
              case 'DATE_TYPE_FIX_TIME_RANGE':
                dealine = Moment(params.row.beginTimestamp).format( 'YYYY年MM月DD日') + ' - ' + Moment(params.row.endTimestamp).format( 'YYYY年MM月DD日')
                break;
              case 'DATE_TYPE_FIX_TERM':
                dealine = params.row.fixedTerm === 0 ? '当天有效' : `${params.row.fixedTerm}天`
                break;
              default:
                break;
            }
            return h('span', {}, dealine)
          }
        },
        {
          title:'领取方式',
          align: 'center',
          width:140,
          render:(h,params) =>{
            let text = '-'
            if (params.row.collectType === 1) {
              text = '输入劵码领取'
              text += params.row.promoCodeType === 1 ? '【一卡一码】' : '【通用码】'
            } else if (params.row.collectType === 2) {
              text = '系统自动下发'
            }
            return h('span', {}, text)
          }
        },
        {
          title:'总库存',
          key:'totalQuantity',
          align:'center',
          width:150
        },
        {
          title:'已领取数量',
          key:'quantity',
          align:'center',
          width:150
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:150,
          render:(h,params)=>{
            return h('div',[              
              h('Button',{
                props:{
                  type:'primary',
                  size:'small'
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    this.handlePromoDetail(params.row.id)
                  }
                }
              },'详情'),
              h('Button',{
                props:{
                  size:'small'
                },
                style:{
                  margin:'3px',
                  display: params.row.collectType === 1 && params.row.promoCodeType === 1 ? 'inline-block' : 'none'
                },
                on:{
                  click:()=>{
                    let type = ''
                    switch (params.row.couponCardType) {
                      case 1:
                        type = `${params.row.exchangeNumber}晚`
                        break;
                      case 2:
                        type = `${params.row.reduceCost/100}元`
                        break;
                      case 3:
                        type = `${params.row.discount/10}折`
                        break;
                    
                      default:
                        break;
                    }
                    if ( !Utils.hasPermission( 'promoCode_codeStore' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    if ( this.$router ) {
                      window.open( `#/app/marketing/codeStore?cardId=${params.row.cardId}&cardName=${params.row.title}`)      //跳转至码库表 
                    } else {
                      window.open( `#/Market/Market/codeStore?cardId=${params.row.cardId}&cardName=${params.row.title}`);
                    }
                  }
                }
              },'券码')
            ])
          }
        },
      ],
      queryParams: {
        page: 1,
        size: 10,
        cardId: '', // 卡券ID
        couponCardType: -1, // 优惠类型，1兑换券, 2代金券, 3折扣券
        bearParty: -1, // 优惠成本，1-Xbed承担；2-业主承担
        titleDescription: '', // 名称/简介
        type: -1, // 时效类型：DATE_TYPE_FIX_TIME_RANGE 表示固定日期区间，DATE_TYPE_FIX_TERM表示固定时长
        collectType: -1 // 领取方式，1劵码领取，2系统下发
      }
    }
  },
  mounted () {
    this.$Notice.config( {
			top: 200
    } );
    this.queryList()
  },
  methods: {
    async queryList(){
      if ( !Utils.hasPermission( 'promoCode_list' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      this.promoCodeLoading = true

      // 过滤空字段
      let params = this.queryParams
      params = Object.keys(params).reduce(function(c, k) {
        if (params[k] && params[k] !== -1) {
          c[k] = params[k]
        }
        return c
      }, {})

      if (params.type === 1) {
        params.type = 'DATE_TYPE_FIX_TIME_RANGE'
      } else if (params.type === 2) {
        params.type = 'DATE_TYPE_FIX_TERM'
      }

      try {
        let resp = (await API.omsAPI[this.env].clientServer.getCouponCard(params, this.protHeaders)).data;
        this.promoCodeLoading = false
        if ( resp.retCode ) {
          this.$Notice.error({
            title: '获取优惠券数据异常',
            desc: resp.msg
          })
          return
        }
        this.dataList = resp.list
        this.listTotal = resp.total
      } catch (e) {
        this.promoCodeLoading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
      
    },
    // 查询
    changeQueryKeyWord(){
      this.queryParams.page = 1
      this.queryList()
    },
    changePageSize(pageSize){
      this.queryParams.size = pageSize
      this.queryParams.page = 1
      this.queryList()
    },
    changePage(page){
      this.queryParams.page = page
      this.queryList()
    },

    // 新增/编辑 跳转
    handlePromoDetail(promoId) {
      let _url = this.$router ? '#/app/marketing/promoCodeEdit' : '#/Market/Market/promoCodeEdit'
      if (promoId) {
        localStorage.setItem("promoCode", promoId)
      } else {
        localStorage.removeItem("promoCode")
      }
      window.open(_url)
    },

    preventSubmit(){
      return false;
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/marketing/promoCodeList.vue